var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",on:{"click":_vm.pushHome}},[_c('img',{staticClass:"logo_img",attrs:{"width":"28","height":"20","src":require("../assets/xueshiyun_logo.png"),"alt":""}}),_c('i',{staticClass:"iconfont iconxueshiyun text_color_active"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0537dc86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xsy-logo.vue
// module id = null
// module chunks = 